import { ReactNode } from 'react'
import clsx from 'clsx'
import { useAuth0 } from 'lib/auth'
import { useAppDispatch } from 'lib/redux'
import { permit } from 'lib/redux/permission'
import { Button } from 'components/common'

export interface Error403Props {
  message?: string | ReactNode
}

export const Error403 = ({ message }: Error403Props): JSX.Element => {
  const { logout } = useAuth0()
  const dispatch = useAppDispatch()

  return (
    <div className={clsx('text-center', 'mt-40')}>
      <h1 className={clsx('text-9xl', 'font-bold', 'mb-8')}>403</h1>
      <h2 className={clsx('text-3xl', 'font-bold', 'mb-6')}>Forbidden</h2>
      {message ? (
        message
      ) : (
        <p>管理画面へのアクセス権限があることを確認してください。</p>
      )}
      <Button
        type="link"
        className={clsx('mt-8')}
        onClick={(e) => {
          e.preventDefault()
          dispatch(permit())
          logout({ returnTo: window.location.origin })
        }}
      >
        ログアウト
      </Button>
    </div>
  )
}
